import { combineReducers } from 'redux';

import auth from '../components/auth/reducer';
import features from '../components/auth/featuresReducer';
import layout from '../layout/reducer';
import pageReducer from '../pages/reducer';
import microgoalsReducer from '../pages/growz/microgoals/reducer';
import aisleReducer from '../pages/aisle/reducer';
import onboardingReducer from '../pages/onboarding/reducer';
import subscriptionReducer from '../pages/growz/subscription/reducer';
import campaignLauncherReducer from '../pages/growz/campaigns/launcher/reducer';
import commonReducer from './commonReducer';

const rootReducer = combineReducers({
  auth,
  features,
  layout,
  page: pageReducer,
  aisle: aisleReducer,
  onboarding: onboardingReducer,
  microgoals: microgoalsReducer,
  subscription: subscriptionReducer,
  campaignLauncher: campaignLauncherReducer,
  common: commonReducer,
});

export default rootReducer;
